type QueueEntry<T> = { action: () => Promise<T>, resolve: (value: T | PromiseLike<T>) => void, reject: (err?: unknown) => void }

export default class AsyncSerializer {
    readonly #queue: Array<QueueEntry<unknown>> = [];
    readonly #bufferSize: number;
    #closed = false;
    #draining = false;


    constructor(bufferSize: number = -1) {
        this.#bufferSize = bufferSize;
    }

    public put<T>(action: () => Promise<T>): Promise<T> {
        return new Promise<T>((resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: unknown) => void) => {
            if (this.#closed) {
                reject(new Error("cannot enqueue promise serializer is closed"));
            }
            const msg: QueueEntry<T> = {action, resolve, reject};
            if (this.#bufferSize < 0 || this.#queue.length < this.#bufferSize) {
                this.#queue.push(msg as QueueEntry<unknown>);
                this.drain();
            } else {
                this.handle(msg);
            }
        });
    }

    public close() {
        this.#closed = true;
    }

    private async drain() {
        if (this.#draining) {
            return;
        }
        try {
            this.#draining = true;
            while (this.#queue.length) {
                const msg = this.#queue.shift();
                if (msg) await this.handle(msg);
            }
        } finally {
            this.#draining = false;
        }
    }

    private async handle<T>(msg: QueueEntry<T>) {
        try {
            const result = await msg.action();
            msg.resolve(result);
        } catch (error) {
            msg.reject(error);
        }
    }
}
